import { type CommonData, Country } from "../../../../types/common";
import { NormalInfoWrapper } from "../../../tasks/styles";
import { RowsWrapper } from "../../styles";
import { formatAmount } from "../../../../utils/helperFunctions";

interface OfferDetailsProps {
  data: CommonData
}

interface Detail {
  label: string,
  value: any,
}

export const ExistingLoanDetailsRow = ({ data }: OfferDetailsProps) => {
  const { ownExperience } = data?.integrations?.leabank ?? {};
  const accountStatus = ownExperience?.data?.mainApplicant?.accountStatus;
  const hadPreviousInsurance = data?.loanApplication?.mainApplicant?.hadPreviousInsurance;

  const statistica = data?.integrations?.statistica;
  let statisticaCoreNo: string | undefined;
  switch (data?.country) {
    case Country.FI:
      statisticaCoreNo = statistica?.FI_External?.latest?.variables?.coreNo;
      break;
    case Country.NO:
      statisticaCoreNo = statistica?.NO_External?.latest?.variables?.coreNo;
      break;
    case Country.SE:
      statisticaCoreNo = statistica?.SE_External?.latest?.variables?.coreNo;
      break;
    default:
      statisticaCoreNo = "";
      break;
  }
  const coreAccountNumber = statisticaCoreNo ?? accountStatus?.coreNo;

  function getIndexOfLastRow(details: Detail[]) {
    let lastValidRow = -1;
    let secondLastValidRow = -1;
    let validCount = 0;

    for (let i = 0; i < details.length; i++) {
      if (details[i].value != null) {
        secondLastValidRow = lastValidRow;
        lastValidRow = i;
        validCount++;
      }
    }

    return validCount % 2 === 0
      ? [secondLastValidRow, lastValidRow]
      : [lastValidRow];
  }

  const existingLoanDetails: Detail[] = [
    // Row 1: Number of active loans | Existing Insurance
    {
      label: "Number of active loans",
      value: accountStatus?.activeLoansCount,
    },
    {
      label: "Existing Insurance",
      value: hadPreviousInsurance === true ? "Yes" :
             hadPreviousInsurance === false ? "No" :
             null,
    },
    // Row 2: Core Account Number | Loan Balance
    {
      label: "Core Account Number",
      value: coreAccountNumber,
    },
    {
      label: "Loan Balance",
      value: formatAmount(accountStatus?.openInvoices, data?.country),
    },
  ]

  const lastIndexes = getIndexOfLastRow(existingLoanDetails)
  return (
    <RowsWrapper className="Existing loan information">
      <NormalInfoWrapper $header>Existing Loan</NormalInfoWrapper>
      {existingLoanDetails.map((detail, index) => {
        if (detail.value === null || detail.value === undefined) return null
        return (
          <NormalInfoWrapper key={`existing-loan-${index}-${detail.label}`} $isLast={lastIndexes.includes(index)}>
            <div>{detail.label}</div>
            <div>{detail.value}</div>
          </NormalInfoWrapper>
        )
      })}
    </RowsWrapper>
  )
}
